import Pagination from './src/pagination'

export default Pagination



// WEBPACK FOOTER //
// ./src/public/components/el-pagination/index.js